import React, { useState, useEffect, useMemo } from 'react';
import 'swiper/css/bundle';
import { SwiperSlide, Swiper } from 'swiper/react';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';
import ProductItemImage from '../../Types/ProductItemImage';
import FullscreenImageSlider from '../FullscreenImageSlider/FullscreenImageSlider';
import { ResponsiveImageModel } from '../../Types/ResponsiveImageModel';
import useReady from '../../Hooks/useReady';
import useIsMobile from '../../Hooks/useIsMobile';
interface ProductPageMobileImagesProps {
  images?: ProductItemImage[];
  videoUrl?: string;
}

interface MediaItem {
  videoUrl?: string;
  imageModel?: ResponsiveImageModel;
}

const ProductPageMobileImages = ({
  images,
  videoUrl,
}: ProductPageMobileImagesProps) => {
  const [activeImageIndex, setActiveImageIndex] = useState<
  number | undefined
  >();
  
  const handleSetActiveImage = (idx) => {
    if (videoUrl) {
      if (idx > 1) {
        //video url is always at idx 1
        setActiveImageIndex(idx - 1);
      } else {
        setActiveImageIndex(idx);
      }
    } else {
      setActiveImageIndex(idx);
    }
  };
  
  const isMobile = useIsMobile();
  const ready = useReady();
  let mediaArray: MediaItem[] | undefined = useMemo(() => {
    if (images?.length == 0 && !videoUrl) return [];
    if (images?.length == 0 && videoUrl) return [{ videoUrl }];
    return videoUrl && images && images.length > 0
      ? [
          { imageModel: images[0]?.imageModel },
          { videoUrl: videoUrl },
          ...images
            .slice(1)
            .map((img) => ({ imageModel: img.imageModel })),
        ]
      : images;
  }, [images, videoUrl]);
  return (
    <>
      {mediaArray && mediaArray.length > 0 && (
        <div className="lg:hidden">
          {!ready && (
            <div className="flex w-full overflow-hidden pl-1">
              {mediaArray[0] && (
                <div className="mr-1 w-[83.9%] rounded bg-gray-100 aspect-[3/4]">
                    <ResponsiveImage
                      {...mediaArray[0].imageModel}
                      pictureProps={{
                        className:
                          'aspect-[3/4] bg-gray-100 rounded overflow-hidden',
                      }}
                      imgProps={{
                        className:
                          'aspect-[3/4] object-cover w-full rounded',
                      }}
                    />
                </div>
              )}
              {mediaArray[1] && (
                <div className="skeleton h-auto flex-1 rounded-l bg-gray-100"></div>
              )}
            </div>
          )}
          {ready && (
            <Swiper
              className="[&_>.swiper-wrapper]:pl-1"
              lazy={true}
              slidesPerView={1.2}
              spaceBetween={4}
              threshold={5}
            >
              {mediaArray.map((mediaItem, idx) => (
                <SwiperSlide
                  key={
                    mediaItem.videoUrl
                      ? mediaItem.videoUrl
                      : mediaItem.imageModel?.alt + '' + idx
                  }
                >
                  {!mediaItem.videoUrl ? (
                    <ResponsiveImage
                      pictureProps={{
                        onClick: () => handleSetActiveImage(idx),
                        className:
                          'aspect-[3/4] bg-gray-100 rounded overflow-hidden',
                      }}
                      imgProps={{
                        className:
                          'aspect-[3/4] object-cover w-full rounded',
                      }}
                      {...mediaItem.imageModel}
                    />
                  ) : (
                    ready && isMobile ?
                    <div className="order-2 w-full overflow-hidden rounded bg-gray-100 object-cover aspect-[3/4]">
                      <video
                        autoPlay
                        playsInline
                        muted
                        loop
                        className="w-full scale-110 overflow-hidden object-cover aspect-[3/4]"
                        src={videoUrl}
                        onClick={() =>
                          setActiveImageIndex(
                            images && images.length > 0 ? 1 : 0
                          )
                        }
                      />
                    </div>
                    :
                    null
                  )}
                </SwiperSlide>
              ))}
            </Swiper>
          )}
          {isMobile && typeof activeImageIndex != 'undefined' && (
            <FullscreenImageSlider
              images={images}
              onClosed={() => setActiveImageIndex(undefined)}
              initialSlide={activeImageIndex}
              videoUrl={videoUrl}
            />
          )}
        </div>
      )}
    </>
  );
};

export default ProductPageMobileImages;
